module.exports = __webpack_public_path__ + "static/media/vizibly-icon.404340b1.png";